import React from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@core-ui/Components/ui/skeleton';

interface Props {
    totalJobs: number;
    totalSuccessful: number;
    totalFailed: number;
    totalCreated: number;
}

interface IntegrationsStatsCardProps {
    label: string;
    value: number | string;
    valueColor: string;
    loading?: boolean;
}

function IntegrationsStatCard ({ 
  label, 
  value, 
  valueColor,
  loading = false,
}: IntegrationsStatsCardProps): React.JSX.Element {
  if (loading) {
    return (
      <div className="rounded-xl border border-border bg-card p-4">
        <Skeleton className="h-4 w-32 bg-muted mb-2" />
        <Skeleton className="h-4 w-14 bg-muted" />
      </div>
    );
  }
  return (
    <div className="rounded-xl border border-border bg-card p-4">
      <span className="mb-2 text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
        {label}
      </span>
      <div className={`text-2xl font-bold tracking-tight ${valueColor}`}>
        {value}
      </div>
    </div>
  );
}

export function IntegrationsStatsCards ({
  totalJobs,
  totalSuccessful,
  totalFailed,
  totalCreated,
}: Props): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <IntegrationsStatCard label={t('dashboard.integrations.statCards.totalJobs', 'Total Jobs')} value={totalJobs} valueColor='text-foreground'/>
      <IntegrationsStatCard label={t('dashboard.integrations.statCards.successful', 'Successful')} value={totalSuccessful} valueColor='text-green-500'/>
      <IntegrationsStatCard label={t('dashboard.integrations.statCards.failed', 'Failed')} value={totalFailed} valueColor='text-red-500'/>
      <IntegrationsStatCard label={t('dashboard.integrations.statCards.created', 'Created')} value={totalCreated} valueColor='text-blue-500'/>
    </div>
  );
}